import request from '@/utils/request'

// 查询服务机构类型列表
export function listFwjglx(query) {
  return request({
    url: '/web/fwjg/fwjglx/list',
    method: 'get',
    params: query
  })
}

// 查询服务机构类型详细
export function getFwjglx(recid) {
  return request({
    url: '/web/fwjg/fwjglx/' + recid,
    method: 'get'
  })
}

// 新增服务机构类型
export function addFwjglx(data) {
  return request({
    url: '/web/fwjg/fwjglx',
    method: 'post',
    data: data
  })
}

// 修改服务机构类型
export function updateFwjglx(data) {
  return request({
    url: '/web/fwjg/fwjglx/edit',

    method: 'post',
    data: data
  })
}

// 删除服务机构类型
export function delFwjglx(recid) {
  return request({
    url: '/web/fwjg/fwjglx/remove/' + recid,

    method: 'post',
  })
}

// 导出服务机构类型
export function exportFwjglx(query) {
  return request({
    url: '/web/fwjg/fwjglx/export',
    method: 'get',
    params: query
  })
}
